import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getVisitHistory } from "../../../../../services/HistoryService";
import { getPatientSingle } from "../../../../../services/PatientService";
import { getParams } from "../../../../../utils/utils";
import { parseListResponse } from "../../../../../utils/parseListResponse";
import HistoryVisitComponent from "../Component";

export default function HistoryVisit() {
  const patientId = getParams("id");

  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [totalEntries, setTotalEntries] = useState(0);
  const [dataHistory, setDataHistory] = useState([]);

  const { isLoading, isRefetching } = useQuery(
    ["HistoryPatientList", patientId, page, size],
    () => getVisitHistory({ page, patientId, size }),
    {
      onSuccess: (data) => {
        if (data.status === 200) {
          // Backend is mid-migration: legacy Spring Boot returns a bare array
          // with x-total-count header, the new Supabase RPC returns
          // {items, total}. parseListResponse handles both.
          const { items, total } = parseListResponse(data);
          setDataHistory(items);
          setTotalEntries(total);
          setTotalPage(Math.ceil(total / size));
        }
      },
    }
  );

  const { isLoading: isLoadingPatient, data: dataPatient } = useQuery(
    ["SinglePatient", patientId],
    () => getPatientSingle(patientId)
  );

  const handlePagination = (value) => {
    setPage(value);
  };

  return (
    <HistoryVisitComponent
      dataHistory={dataHistory}
      isLoading={isLoading || isRefetching || isLoadingPatient}
      totalPage={totalPage}
      totalEntries={totalEntries}
      activePage={page}
      sizePerPage={size}
      handlePagination={handlePagination}
      handleSizePerPage={setSize}
      itemData={dataPatient?.data || null}
    />
  );
}
